import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetEducationDetailResponse {
  educationId: string;
  collageParameterId?: string;
  countryParameterId?: string;
  departmentParameterId?: string;
  graduationStatusParameterId?: string;
  schoolName: string;
  departmentName: string;
  registeredYear: number;
  graduationYear: number;
  degree: number;
  isContinue: boolean;
  isCertificate: boolean;
  isItPersonnel: boolean;
}

export interface UpdateEducationPayload {
  educationId: string;
  collageParameterId?: string;
  countryParameterId?: string;
  departmentParameterId?: string;
  graduationStatusParameterId?: string;
  schoolName: string;
  departmentName: string;
  registeredYear: number;
  graduationYear: number;
  degree: number;
  isContinue: boolean;
  isCertificate: boolean;
  isItPersonnel: boolean;
}

export const getEducationDetail = async (
  educationId: string
): Promise<GetEducationDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetEducationDetail/${educationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    }
  );
  return response.data?.data || response.data;
};

export const updateEducationInfo = async (
  payload: UpdateEducationPayload
): Promise<any> => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${SERVICEURL}api/Candidates/UpdateEducationInfo`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        accept: "*/*",
      },
    }
  );
  return response.data;
};

export const deleteEducationInfo = async (
  educationId: string
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(
    `${SERVICEURL}api/Candidates/DeleteEducationInfo/${educationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
